import React, { type FC } from 'react'
import { useRecoilValue } from 'recoil'

import { Flex } from 'mailup-web-components'

import { searchFiltersState } from 'Pages/RecipientsList/recoil/state/filters'

import CriterionUndefined from 'Pages/RecipientsList/components/filters/CriterionUndefined'

import CriterionAnagraphicField from 'Pages/RecipientsList/components/filters/CriterionAnagraphicField'
import CriterionFilters from 'Pages/RecipientsList/components/filters/CriterionFilters'
import CriterionGroups from 'Pages/RecipientsList/components/filters/CriterionGroups'
import CriterionOptinOptoutDate from 'Pages/RecipientsList/components/filters/CriterionOptinOptoutDate'
import CriterionOptoutMessage from 'Pages/RecipientsList/components/filters/CriterionOptoutMessage'
import CriterionOptoutType from 'Pages/RecipientsList/components/filters/CriterionOptoutType'
import CriterionPendingDate from 'Pages/RecipientsList/components/filters/CriterionPendingDate'

const Criteria: FC = () => {
  const {
    criteria: { value },
  } = useRecoilValue(searchFiltersState)

  if (value.length === 0) return null

  return (
    <Flex flexDirection="column" gap="16px">
      {/* <pre>{JSON.stringify(value, null, 2)}</pre>... */}
      {value.map(({ critType }, index) =>
        critType === 'undefined' ? (
          <CriterionUndefined key={index} index={index} />
        ) : critType === 'anagraphicField' ? (
          <CriterionAnagraphicField key={index} index={index} />
        ) : critType === 'groups' ? (
          <CriterionGroups key={index} index={index} />
        ) : critType === 'optinDate' ? (
          <CriterionOptinOptoutDate key={index} index={index} />
        ) : critType === 'optoutDate' ? (
          <CriterionOptinOptoutDate key={index} index={index} />
        ) : critType === 'pendingDate' ? (
          <CriterionPendingDate key={index} index={index} />
        ) : critType === 'optoutType' ? (
          <CriterionOptoutType key={index} index={index} />
        ) : critType === 'optoutMessage' ? (
          <CriterionOptoutMessage key={index} index={index} />
        ) : critType === 'filters' ? (
          <CriterionFilters key={index} index={index} />
        ) : null,
      )}
    </Flex>
  )
}

export default Criteria
